import { Component, OnInit, ElementRef, NgZone, ViewChild, ViewContainerRef } from '@angular/core';
import { MouseEvent } from '@agm/core';
import {Router} from "@angular/router";


import {PublicationService} from "../nservices/publication.service";
import {Post} from "../models/post.model";
import {PostResponse} from "../models/postResponse.model";
import {Credentials} from "../models/credentials";
import {LocalDataService} from "../services/local-data.service";

//Para el Autocomplet de lugares

import { FormControl } from '@angular/forms';
import { } from 'googlemaps';
import { MapsAPILoader } from '@agm/core';
import {} from '@types/googlemaps';
import { CredentialsService } from '../nservices/login/credentials.service';
import { PublicationModel } from '../nmodels/publication.model';
import { ToastsManager } from 'ng2-toastr';

@Component({
  selector: 'app-new-post',
  templateUrl: './new-post.component.html',
  styleUrls: ['./new-post.component.css']
})
export class NewPostComponent implements OnInit {

  //Hidden the maps landmarks default
  public whitoutPoints = [{
      "featureType": "poi",
      "elementType": "labels",
      "stylers": [{
          "visibility": "off"
        }]
      }
    ];

  @ViewChild('search')
  public searchElement:ElementRef


  postResponse:PostResponse;

  publication:PublicationModel;
  zoom:number;
  lat?:number;
  lng?:number;
  comment_date?:Date;
  comment_time?:string;
  file:string;
  filename:string = "Selecciona una fotografia";
  searchControl: FormControl;


  constructor(private _publicationS:PublicationService,
              private _localDS:LocalDataService,
              private _router:Router,
              private mapsAPILoader: MapsAPILoader,
              private ngZone: NgZone,
    private _credentialsS:CredentialsService,public toastr: ToastsManager, vcr: ViewContainerRef) {
      this.toastr.setRootViewContainerRef(vcr);
      if(!this._credentialsS.getCredentials()){
        this._router.navigate(['login']);
      }else{
        this.publication = new PublicationModel();
        this.publication.private = "0";
        this.publication.device_type = "web";
        this.publication.datetime_event = "";
      }
  }


  ngOnInit() {
    this.zoom = 4;
    this.lat = 43.2388841;
    this.lng = -79.8897273;
    this.searchControl = new FormControl();
    this.setCurrentPosition();
    this.mapsAPILoader.load().then(
      ()=>{
        let autocomplete = new google.maps.places.Autocomplete(this.searchElement.nativeElement,{
        });
        autocomplete.addListener("place_changed", ()=>{
          this.ngZone.run(
            ()=>{
              let place: google.maps.places.PlaceResult = autocomplete.getPlace();
              if (place.geometry === undefined || place.geometry === null) {
                  return;
              }
            this.lat = place.geometry.location.lat();
            this.lng = place.geometry.location.lng();
            this.zoom = 17;
            this.publication.latitude_event = String(place.geometry.location.lat());
            this.publication.longitude_event = String(place.geometry.location.lng());
            }
          )
        })
      }
    );


  }

  createPublication(){
    this.buildPost();
    this._publicationS.createPublication(this.publication)
        .subscribe(resp =>{
          this.postResponse = resp;
          // this.toastr.success('realizada con exito', 'Publicación '+this.postResponse.post.title);
          // alert("Publicación "+this.postResponse.post.title+" realizada con exito");
          // this._router.navigate(['home']);
          this.toastr.success('realizada con exito', 'Publicación '+this.postResponse.post.title);
        })
  }

  onChange(event: EventTarget) {
   let eventObj: MSInputMethodContext = <MSInputMethodContext> event;
   let target: HTMLInputElement = <HTMLInputElement> eventObj.target;
   let files: FileList = target.files;
   let file = files[0];
   this.filename = file.name;
   console.log("file");
    console.log(file);
    this.getBase64(file);
 }
 getBase64(file) {
   return new Promise((resolve, reject) => {
     const reader = new FileReader();
     reader.readAsDataURL(file);
     reader.onload = () => resolve(reader.result);
     reader.onerror = error => reject(error);
    }).then(
      data =>this.publication.file = String(data)
    );
  }

  buildPost(){
    if(!this._credentialsS.getCredentials()){
      // this.toastr.error('te invitamos a inicar sesion nuevamente', 'Parece que tu session ha caducado');
      // alert("Parece que sesion ha caducado, te invitamos a iniciar sesion nuevamente");
      this._router.navigate(['login']);
      this.toastr.error('te invitamos a inicar sesion nuevamente', 'Parece que tu session ha caducado');
    }
    else{
      if(!this.publication.title)this.publication.title = "Sin Título";
      if(!this.publication.comment)this.publication.comment = "Sin Comentario";
      if(this.comment_date) this.publication.datetime_event = this.publication.datetime_event+this.comment_date.valueOf().toString();
      if(this.comment_time) this.publication.datetime_event = this.publication.datetime_event+" "+this.comment_time;
    }
  }

    setCurrentPosition() {
      if ("geolocation" in navigator) {
        navigator.geolocation.getCurrentPosition((position) => {
          this.setLocationData(String(position.coords.latitude),String(position.coords.longitude),16);
          });
        } else{
          this.setLocationData();
        }

      }

    markerDragEnd(m: marker, $event: MouseEvent) {
        this.publication.latitude_event = String($event.coords.lat);
        this.publication.longitude_event = String($event.coords.lng);
    }
    setLocationData(lat:string="18.2084564",lng:string="-73.8974265",zoom:number=4){
      console.log("location data lat: "+lat+" lng:"+lng);

      this.zoom = zoom;
      this.publication.latitude_event = lat;
      this.publication.longitude_event = lng;
      this.publication.latitude_publication = lat;
      this.publication.longitude_publication = lng;
    }

}

interface marker {
	lat: number;
	lng: number;
	label?: string;
	draggable?: boolean;
}



// WEBPACK FOOTER //
// C:/Users/CLAUDIA/Desktop/Timeplacebook2/src/app/new-post/new-post.component.ts